import Country from '~/Api/Country/Country';

import PriceTime from './PriceTime';

export enum Status {
	hasPrice = 'has-price',
	noPriceSet = 'no-price-set',
	dataUnavailable = 'data-unavailable',
}

export default class TimeToPrice {
	country: Country;

	minDays: number | null;

	status: Status;

	times: PriceTime[];

	constructor(country: Country, minDays: number | null, status: Status, times: PriceTime[]) {
		this.country = country;
		this.minDays = minDays;
		this.status = status;
		this.times = times;
	}

	get hasNoPriceSet() {
		return this.status === Status.noPriceSet;
	}

	get hasUnavailableData() {
		return this.status === Status.dataUnavailable;
	}
}
